export enum StorageCargoPalletDetailsActionTypes {
  STORAGE_ADD_NEW_PALLET_LINE_ITEM = "STORAGE_ADD_NEW_PALLET_LINE_ITEM",
  STORAGE_REMOVE_PALLET_LINE_ITEM = "STORAGE_REMOVE_PALLET_LINE_ITEM",
  STORAGE_UPDATE_PALLET_LINE_ITEM = "STORAGE_UPDATE_PALLET_LINE_ITEM",
  SET_IS_CALCULATE_RATE_DISABLED = "SET_IS_CALCULATE_RATE_DISABLED",
}
